export default function validateTestTaskInitials(value?: string) {
  let error;
  return error;
}
